import { Helmet } from 'react-helmet-async';

import { Content } from './components/Content';
import { PageProvider } from './providers/PageProvider';

export const AdminAuditLogsPage = () => {
  return (
    <>
      <Helmet>
        <title>Audit Log - AutoScript Admin</title>
      </Helmet>

      <PageProvider>
        <Content />
      </PageProvider>
    </>
  );
};
